import { Component, DestroyRef, InputSignal, OnInit, WritableSignal, inject, input, signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AccountService } from '../../account.service';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeliveriesService } from '../../../settings/account/deliveries/deliveries.service';
import { UpdateDeliveryInfoPayload } from '../../../settings/account/deliveries/intarfaces';
import { DeliveryOptionsResponseItem } from '../../types/account.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '../../notification/notification.service';

@Component({
    selector: 'app-delivery-day-selection',
    imports: [
        MatFormFieldModule,
        MatSelectModule
    ],
    templateUrl: './delivery-day-selection.component.html',
    styleUrl: './delivery-day-selection.component.scss'
})
export class DeliveryDaySelectionComponent implements OnInit {

  private accountService = inject(AccountService);
  private deliveriesService = inject(DeliveriesService);
  private activeModal = inject(NgbActiveModal);
  #notificationService = inject(NotificationService);
  private destroyRef = inject(DestroyRef);

  zoneId: InputSignal<number> = input(0, { alias: 'zoneId' });

  deliveryOptions: WritableSignal<DeliveryOptionsResponseItem[]> = signal([]);
  selectedDeliveryDay: WritableSignal<DeliveryOptionsResponseItem | null> = signal(null);

  ngOnInit(): void {
    this.accountService.fetchDeliveryOptions(this.zoneId()).pipe(
      tap((options) => this.deliveryOptions.set(options ?? [])),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe()
  }

  saveDaliveryDay() {
    const payload = this.setUpDeliveryInfoPayload();
    this.deliveriesService.updateDeliveryInfo(payload).pipe(
      tap((response: any) => {
        // DEV-9289: the service now surfaces backend errors instead of
        // swallowing them, so only close on success. Closing unconditionally
        // reported a rejected change (e.g. PREORDER_WINDOW_CONFLICT) as saved
        // and left the customer thinking their delivery day had changed.
        if (response?.error) {
          this.#notificationService.show({ text: response.message || 'Something went wrong', type: 'error' });
          return;
        }
        this.activeModal.close(true);
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }

  private setUpDeliveryInfoPayload(): UpdateDeliveryInfoPayload {
    return {
      dayId: this.selectedDeliveryDay()?.id,
      timeWindowId: null,
      shouldAffectCustomerInfo: true
    } as UpdateDeliveryInfoPayload
  }

  setSelectedDeliveryDay(value: number) {
    this.selectedDeliveryDay.set(this.deliveryOptions().find(o => o.id === value) ?? null);
  }
}
